export default __webpack_public_path__ + "static/media/Inserts.bbfe968d.png";